<template>
  <div>
    <div class="pass-cert"></div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="90%"
      v-if="resposeType == '1'"
      :before-close="handleClose"
    >
      <span>是否同意授权证书</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="unpassCert()">不同意</el-button>
        <el-button type="primary" @click="passCert()">同意</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const Base64 = require("js-base64").Base64;
import { responseAuthorize,currentAuthorize} from "@/apis/index";

//getAllFile
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  data() {
    return {
      test: "",
      dialogVisible: true,
      idCard: "",
      companyId: "",
      resposeType:""
    };
  },
  mounted() {
    this.idCard = this.$route.query.id || "";
    this.companyId = this.$route.query.companyId || "";
    this.currentAuthorizeList();
  },
  created() {},
  methods: {
    handleClose() {
      this.dialogVisible = false;
    },
    async passCert() {
      // console.log(data);
      let idCard = Base64.decode(this.idCard);
      let companyId = Base64.decode(this.companyId);
      const res = await responseAuthorize({
        authorizeResult: "2",
        authorizeType: "1",
        companyId: companyId,
        idCardNo: idCard,
      });
      // console.log(res);
      this.$message({
        message: "授权成功",
        type: "success",
      });
      this.dialogVisible = false;
    },
    async currentAuthorizeList() {
      let idCard = Base64.decode(this.idCard);
      let companyId = Base64.decode(this.companyId);
      let res = await currentAuthorize({
        companyId: companyId,
        idCardNo: idCard,
        authorizeType: "1",
      });
      this.resposeType = res.data || "";
      if (this.resposeType != '1') {
        this.$message({
        message: "链接已失效！",
        type: "error",
      });
      }
      // console.log(res);
    },
    async unpassCert() {
      // console.log(data);
      let idCard = Base64.decode(this.idCard);
      let companyId = Base64.decode(this.companyId);
      const res = await responseAuthorize({
        authorizeResult: "3",
        authorizeType: "1",
        companyId: companyId,
        idCardNo: idCard,
      });
      // console.log(res);
      this.$message({
        message: "拒绝授权成功！",
        type: "success",
      });
      this.dialogVisible = false;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
